<template>
  <div class="multipleFill">
    <el-input
      v-model="answer"
      @change="change"
      type="textarea"
      :rows="3"
      :placeholder="question.tips || `请输入${question.label}`"
    ></el-input>
  </div>
</template>

<script>
import mixins from "./mixins";

export default {
  name: "multipleFill",
  mixins: [mixins],
  data() {
    return {
      answer: "",
    };
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>